import React, { Component } from 'react'
import moment from 'moment'
import { withRouter } from 'react-router'

import { Input, DatePicker, TextArea, Checkbox } from 'src/components/Form'
import { Form, Field } from 'react-final-form'
import { Layout, Container } from 'src/components/Layout'
import Disclaimer from 'src/modals/Disclaimer'

import { WidgetContext } from 'src/modules/App/WidgetContext'
import { injectIntl, FormattedMessage } from 'react-intl'
import { isEmpty } from 'src/utils/helpers'
import intlMessages from '../translations'
import { Box, Text } from '@chakra-ui/react'
import Button from 'src/components/Button/Button'

import withToast from 'src/components/Toast'
import PageTitle from 'src/components/Layout/PageTitle/PageTitle'
import { validateEmail, validateName } from 'src/utils/validation'

class GetQuote extends Component {
  state = {
    quote: {},
    showDisclaimer: false,
    currentDate: moment(),
  }

  componentDidUpdate(prevProps) {
    const { intl, submitting, history, successful, toast } = this.props
    if (submitting === false && prevProps.submitting === true && successful) {
      history.push('/quote')
      toast({
        title: intl.formatMessage(intlMessages.quoteNotificationThankYou),
        description: intl.formatMessage(intlMessages.quoteNotificationSuccessMsg),
        status: 'success',
      })
    }

    if (submitting === false && prevProps.submitting === true && !successful) {
      toast({
        message: intl.formatMessage({
          id: 'quotes.response.error.message',
          defaultMessage: this.props.responseErrorMessage,
        }),
        description: intl.formatMessage({
          id: 'quotes.response.error.message',
          defaultMessage: this.props.responseErrorMessage,
        }),
        status: 'error',
      })
    }
  }

  handleSubmit = values => {
    this.setState({
      quote: values,
      showDisclaimer: true,
    })
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}

    if (!values.name) {
      errors.name = intl.formatMessage(intlMessages.quoteValidationName)
    }

    if (values.name && !validateName(values.name)) {
      errors.name = intl.formatMessage(intlMessages.quoteValidationNameValid)
    }

    if (!values.phoneNumber) {
      errors.phoneNumber = intl.formatMessage(intlMessages.quoteValidationNumber)
    }

    if (!values.email) {
      errors.email = intl.formatMessage(intlMessages.quoteValidationEmailRequired)
    }

    if (values.email && !validateEmail(values.email)) {
      errors.email = intl.formatMessage(intlMessages.quoteValidationEmailNotValid)
    }

    return errors
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { quote } = this.state

    if (isEmpty(quote)) {
      return false
    }

    const { expiryDate, ...rest } = quote

    this.props.sendQuote({
      type: this.props.match.params.type,
      expiryDate: expiryDate ? moment(expiryDate).format('YYYY-MM-DD') : null,
      ...rest,
    })
  }

  componentDidMount() {
    const { quoteOptions, user, history } = this.props
    const currentQuote = quoteOptions.find(q => q.id == this.props.match.params.type)
    const { settings } = currentQuote
    // detech when user directly wants to access get quote page with url and quote is disabled or hidden
    if (
      currentQuote.isEnabled &&
      ((settings && settings.isHiddenUnlessLoggedIn && user) || !settings.isHiddenUnlessLoggedIn) &&
      ((settings && settings.isLoginRequired && user) || !settings.isLoginRequired)
      // eslint-disable-next-line no-empty
    ) {
    } else {
      history.push('/quote')
    }
  }

  render() {
    const { submitting, intl, location, features } = this.props
    const { showDisclaimer } = this.state

    const foundedFeature = features.find(f => f.id == 'requestQuote')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.quoteHeader)

    const heading =
      (location.state && location.state.listItem && location.state.listItem.name) || ''
    return (
      <Layout>
        <PageTitle title={heading} subtitle={title} />
        <Container padder className='global-centered-desktop-content'>
          <Box mt={{ base: '20px' }}>
            <Form
              onSubmit={this.handleSubmit}
              validate={this.validateFormFields}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    name='name'
                    render={({ input, meta }) => (
                      <Box mb={2.5}>
                        <Input
                          name='name'
                          placeholder={intl.formatMessage(intlMessages.quotePlaceholderName)}
                          error={meta}
                          type='text'
                          {...input}
                        />
                      </Box>
                    )}
                  />

                  <Field
                    name='phoneNumber'
                    render={({ input, meta }) => {
                      return (
                        <Box mb={2.5}>
                          <Input
                            name='phoneNumber'
                            placeholder={intl.formatMessage(intlMessages.quotePlaceholderNumber)}
                            error={meta}
                            type='text'
                            {...input}
                            onChange={e => {
                              const value = e.target.value.match(/[0-9 _!@$%^&*()'"/*+.-]/g)
                              if (value) {
                                e.target.value = value.join('')
                              } else {
                                e.target.value = ''
                              }
                              input.onChange(e)
                            }}
                          />
                        </Box>
                      )
                    }}
                  />

                  <Field
                    name='email'
                    render={({ input, meta }) => (
                      <Box mb={'10px'}>
                        <Input
                          name='email'
                          placeholder={intl.formatMessage(intlMessages.quotePlaceholderEmail)}
                          error={meta}
                          type='text'
                          {...input}
                        />
                      </Box>
                    )}
                  />
                  <Field
                    name='expiryDate'
                    initialValue={moment().format('LLL')}
                    placeholder={intl.formatMessage(intlMessages.quotePlaceholderDate)}
                    component={DatePicker}
                  />

                  <Field
                    name='comment'
                    render={({ input }) => (
                      <Box mt={'16px'} mb={'25px'}>
                        <TextArea
                          name='comment'
                          placeholder={intl.formatMessage(intlMessages.quotePlaceholderComments)}
                          {...input}
                        />
                      </Box>
                    )}
                  />

                  <Field
                    name='newsletterSubscribe'
                    render={({ input }) => (
                      <Box my={5} style={{ textAlign: 'center' }}>
                        <Checkbox
                          variant='secondary'
                          name='newsletterSubscribe'
                          label={
                            <Text variant='secondary' fontSize={'14px'}>
                              <FormattedMessage
                                id='app.quote.subscribe'
                                defaultMessage={'Subscribe to our email list'}
                              />
                            </Text>
                          }
                          {...input}
                        />
                      </Box>
                    )}
                  />

                  <Button isFullWidth size='lg' type='submit' data-qa='button-submit-quote'>
                    <FormattedMessage id='app.quote.submit' defaultMessage={'Submit'} />
                  </Button>
                </form>
              )}
            />
            <Disclaimer
              visible={showDisclaimer}
              loading={submitting}
              skipAfterHoursCheck={true}
              onClose={this.handleCloseDisclaimer}
              onSubmit={this.handleSubmitDisclaimer}
            />
          </Box>
        </Container>

        {/* <NavBottom /> */}
      </Layout>
    )
  }
}

const GetQuoteContext = props => (
  <WidgetContext.Consumer>{context => <GetQuote {...props} {...context} />}</WidgetContext.Consumer>
)

export default withRouter(injectIntl(withToast(GetQuoteContext)))
